import config from './config'
import cpSite from './cpSite'
import { waitModuleReady } from './waitModuleReady'
import { loadScript } from './loadScript'

let init = false

const cpKeyTestServiceForm = {
  depend: ['vue', 'element-ui'],
  state: {
    isActive: false,
    lib: config.DEVMODE ? ['js/embed-cpkey-test-form/vue.base.js'] : [config.THEME + 'js/embed-cpkey-test-form/vue.base.js']
  },
  activate: function () {
    if (cpSite.config.DEVMODE) {
      console.log('active: cpKeyTestServiceForm')
    }
    // Не проводить повторную инициализацию
    if (init) {
      // Если инициализация началась, но не дошла до конца (не загрузились библиотеки), то перезагрузить страницу
      if (!cpSite.module.cpKeyTestServiceForm?.show) {
        window.location.reload()
      }
      cpSite.module.cpKeyTestServiceForm.show()
      return
    }

    // Критерий дальнейшего запуска
    const querySelector = 'embed-cpkey-test-form'
    const cpkeyEl = document.querySelector(querySelector)
    // Если объекта нет, то добавить
    if (!cpkeyEl) {
      if (config.DEVMODE) {
        console.log('cpKeyTestServiceForm: no element and add')
      }
      // Вставка элемента для наполнения и продолжить
      document.body.insertAdjacentHTML('beforeend', '<embed-cpkey-test-form></embed-cpkey-test-form>')
    }

    // Инициализация
    init = true
    this.activateElementUi(this)
    // Ожидание готовности новых скриптов
    waitModuleReady(() => (window.Vue && window.Vue.options.components?.ElButton), () => { this.embedCPkeyTestForm() }, 30)
  },
  activateElementUi () {
    cpSite.module.elementUi.activate()
  },
  embedCPkeyTestForm () {
    cpSite.module.elementUi.ru()
    loadScript(this.state.lib[0])
    this.state.isActive = true
  }
}
export default cpKeyTestServiceForm
